import { baseApi } from "@/shared/api";
import type { OrganizationMe, OrganizationMeUpdate } from "../types";

export const organizationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyOrganization: builder.query<OrganizationMe, void>({
      query: () => ({
        url: "/api/organizations/me/",
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: [{ type: "Organization" as const, id: "ME" }],
    }),
    updateMyOrganization: builder.mutation<OrganizationMe, OrganizationMeUpdate>({
      query: (body) => ({
        url: "/api/organizations/me/",
        method: "PATCH",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Organization" as const, id: "ME" }],
    }),
    uploadOrganizationPhoto: builder.mutation<OrganizationMe, File>({
      query: (file) => {
        const formData = new FormData();
        formData.append("photo", file);
        return {
          url: "/api/organizations/me/photo/",
          method: "POST",
          body: formData,
          credentials: "include" as const,
        };
      },
      invalidatesTags: [{ type: "Organization" as const, id: "ME" }],
    }),
    deleteOrganizationPhoto: builder.mutation<OrganizationMe, void>({
      query: () => ({
        url: "/api/organizations/me/photo/",
        method: "DELETE",
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Organization" as const, id: "ME" }],
    }),
  }),
});

export const {
  useGetMyOrganizationQuery,
  useUpdateMyOrganizationMutation,
  useUploadOrganizationPhotoMutation,
  useDeleteOrganizationPhotoMutation,
} = organizationApi;
